import React from "react";
import "./footer.css";
import { BASE_URL } from "../constants";
const Footer = ({ websiteSetting }) => {
  return (
    <footer className="mt-2">
      <div className="footer-container">
        <div className="footer-left">
          <div className="logoAndName">
            <img
              src={`${BASE_URL + "/" + `${websiteSetting?.logo}`}`}
              alt="bg"
              style={{
                width: "20%",
                height: "auto",
                objectFit: "contain",
                marginRight: "0.4rem",
              }}
            />
            <div>
              <h1>AL-MUNIR</h1>
              <span>Lighting the Path to Knowledge and Success</span>
            </div>
          </div>
          <p>
            At Al-Munir School & Academy, we believe that true education unites
            knowledge with faith — nurturing both the mind and the soul. Through
            our commitment to excellence, we empower students to learn with
            purpose, lead with integrity, and contribute meaningfully to
            society.
          </p>
        </div>

        <div className="footer-right">
          <h3>Contact Us?</h3>
          <ul>
            <li>
              <i className="fa fa-map"></i>
              {websiteSetting?.address}
            </li>
            <li>
              <i className="fa fa-phone-alt"></i>
              {websiteSetting?.phone}
            </li>
            <li>
              <i className="fa fa-paper-plane"></i>
              {websiteSetting?.email}
            </li>
          </ul>
          <iframe
          title="map"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13290.235752790997!2d73.0580858!3d33.6167467!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df94ec83ef2cdd%3A0x7269f496fc8c44da!2sHanif%20Jewellers!5e0!3m2!1sen!2s!4v1723374163294!5m2!1sen!2s"
            height="400"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
